import React, { useCallback } from 'react';
import _ from "lodash";

import {
    Typography
} from '@material-ui/core';

import AsyncSelect from 'react-select/async'

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
    root: {
        width: '100%'
    }
}));

export const SelectAsync = ({
    label,
    placeholder,
    loadOptions,
    getOptionLabel,
    getOptionValue,
    value,
    delay,
    disabled,
    onChange,
    onBlur,
    ...props }) => {
    const classes = useStyles();

    // We use lodash debounce to avoid gazillion of request
    // We use the old fashion promise way because react select + debounce 
    // seems to work well only when using promises :(
    //
    // https://github.com/JedWatson/react-select/issues/3075
    //
    // We also use the useCallback for the reason below
    // https://rajeshnaroth.medium.com/using-throttle-and-debounce-in-a-react-function-component-5489fc3461b3
    const loadData = useCallback(_.debounce((value, callback) => {
        if (loadOptions) loadOptions(value, callback);
        else callback([]);
    }, 500), []);

    return (
        <>
            {label &&
                <Typography variant="overline">{label}</Typography>
            }
            <AsyncSelect
                {...props}
                isClearable
                placeholder={placeholder || "Type to search..."}
                loadOptions={loadData}
                menuPortalTarget={document.body}
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                getOptionLabel={getOptionLabel}
                getOptionValue={getOptionValue}
                value={value}
                isDisabled={disabled}
                onChange={onChange}
                onBlur={onBlur}
            />
        </>
    );
}